export const WALLET_ROUTE= "/wallet"
